/**
 * User avatar — uploaded photo overrides self-hosted DiceBear (seed: user_id).
 * Do not use for verified advisor headshots (use PortraitFrame).
 */
import React, { useMemo } from 'react';
import { resolveUserAvatarSrc } from '../../utils/userAvatar';

const SIZES = {
  xs: 'w-8 h-8',
  sm: 'w-10 h-10',
  md: 'w-14 h-14',
  lg: 'w-20 h-20',
};

const UserAvatar = ({
  userId,
  src,
  alt = '',
  size = 'sm',
  className = '',
  rounded = 'full',
}) => {
  const imgSrc = useMemo(
    () => resolveUserAvatarSrc({ userId, avatarUrl: src }),
    [userId, src]
  );

  const sizeClass = SIZES[size] || SIZES.sm;
  const roundClass = rounded === 'lg' ? 'rounded-lg' : 'rounded-full';

  if (!imgSrc) {
    return (
      <div
        className={`${sizeClass} ${roundClass} bg-pine shrink-0 flex items-center justify-center ${className}`}
        aria-hidden
      />
    );
  }

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={`${sizeClass} ${roundClass} object-cover shrink-0 border border-hairline bg-bone-raised ${className}`}
    />
  );
};

export default UserAvatar;
